import { motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';

import { SABER_BLUE, SPACE_BLACK } from '../constants';

export function OpeningCrawl() {
  const { t } = useTranslation(['components/trial/lp/v4b']);

  return (
    <div className='relative w-full overflow-hidden' style={{ height: 320, perspective: 400 }}>
      <motion.div className='absolute inset-x-0 px-8 text-center' style={{ transformOrigin: '50% 100%', transform: 'rotateX(25deg)', fontFamily: 'var(--font-bai)' }} initial={{ y: 300 }} animate={{ y: -600 }} transition={{ duration: 25, ease: 'linear', repeat: Infinity }}>
        <p className='mb-6 text-lg leading-relaxed md:text-xl' style={{ color: SABER_BLUE }}>
          {t('opening_crawl.episode')}
        </p>
        <h3 className='mb-8 text-2xl font-bold md:text-3xl' style={{ color: '#FFE81F' }}>
          {t('opening_crawl.title')}
        </h3>
        <div className='mx-auto max-w-md text-sm leading-loose md:text-base' style={{ color: SABER_BLUE }}>
          <p className='mb-4'>{t('opening_crawl.paragraph_1')}</p>
          <p className='mb-4'>{t('opening_crawl.paragraph_2')}</p>
          <p>{t('opening_crawl.paragraph_3')}</p>
        </div>
      </motion.div>
      <div className='pointer-events-none absolute inset-x-0 bottom-0 h-24' style={{ background: `linear-gradient(transparent, ${SPACE_BLACK})` }} />
      <div className='pointer-events-none absolute inset-x-0 top-0 h-16' style={{ background: `linear-gradient(${SPACE_BLACK}, transparent)` }} />
    </div>
  );
}
